import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SearchCriteriaSubject {
    private searchCriteriaSubject = new BehaviorSubject<any | null>(null);
    searchCriteria$ = this.searchCriteriaSubject.asObservable();

    setSearchCriteria(criteria: any): void {
        this.searchCriteriaSubject.next(criteria);
    }

    getSearchCriteria(): any {
        return this.searchCriteriaSubject.getValue();
    }
}
